import { DataVizPalette, getColorFromToken, ILegend, Legends, LineChart } from "@fluentui/react-charting";
import { IStandardChartData } from "models/IChartData";

export const CustomLineChart = ({ chartData }: { chartData: IStandardChartData }) => {
    const { x, series, x_label, y_label, title } = chartData;

    const lineChartData = series.map((s, index) => ({
        legend: s.name,
        data: x.map((item, i) => ({
            x: new Date(item),
            y: s.y[i] || 0,
        })),
        color: getColorFromToken(DataVizPalette[`color${(index % 10) + 1}` as keyof typeof DataVizPalette]),
    }));

    const data = {
        chartTitle: title,
        lineChartData: lineChartData,
        xAxisTitle: x_label,
    };

    const legends: ILegend[] = lineChartData.map((item) => ({
        title: item.legend,
        color: item.color,
        action: () => console.log(`${item.legend} clicked`),
    }));

    return (
        <div style={{ maxWidth: "800px", textAlign: "center", margin: "auto" }}>
            <LineChart
                data={data}
                height={500}
                width={600}
                legendsOverflowText="See More Data"
                yMinValue={Math.min(...series.flatMap(s => s.y))}
                yMaxValue={Math.max(...series.flatMap(s => s.y))}
                margins={{ left: 50, top: 30, bottom: 80, right: 30 }}
                xAxisTitle={x_label}
                yAxisTitle={y_label}
                hideLegend={true}
            />

            <div style={{ maxHeight: "120px", maxWidth: '600px', overflowY: "auto", marginTop: "10px" }}>
                <Legends
                    enabledWrapLines={true}
                    legends={legends}
                    allowFocusOnLegends={true}
                    canSelectMultipleLegends={false}
                    overflowText={"See More Legends"}
                />
            </div>
        </div>
    );
};